if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Clear all items from cart
      async clearCart() {
        try {
          const config = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          };

          const clearResponse = await fetch('/cart/clear.js', config);
          return clearResponse.ok;
        } catch (e) {
          console.error('Error clearing cart:', e);
          return false;
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const scope = this.closest('section') || document;
        const parentGroupId = `main_${Date.now()}_${Math.random().toString(36).substring(2, 8)}`;

        const selectedAddons = Array.from(scope.querySelectorAll('.js-addon-input:checked'))
          .map(el => {
            const vid = el.dataset.addonVariantId;
            return vid ? { variantId: vid, title: el.value } : null;
          })
          .filter(Boolean);

        const buildConfigWithSections = () => {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          return config;
        };

        const attachSectionsToFormData = fd => {
          if (this.cart) {
            fd.append(
              'sections',
              this.cart.getSectionsToRender().map(section => section.id)
            );
            fd.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          return fd;
        };

        let finalResponse = null;
        let errorHappened = false;

        try {
          // Clear cart first
          await this.clearCart();

          const configMain = buildConfigWithSections();
          const formDataMain = new FormData(this.form);
          formDataMain.append('properties[_group_id]', parentGroupId);
          attachSectionsToFormData(formDataMain);
          configMain.body = formDataMain;

          const respMain = await fetch(`${routes.cart_add_url}`, configMain).then(r => r.json());
          finalResponse = respMain;

          if (respMain.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formDataMain.get('id'),
              errors: respMain.errors || respMain.description,
              message: respMain.message
            });
            this.handleErrorMessage(respMain.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            errorHappened = true;
          }

          if (!errorHappened) {
            // Add all addons
            for (const addon of selectedAddons) {
              const configAddon = buildConfigWithSections();
              const fd = new FormData();
              fd.append('id', addon.variantId);
              fd.append('quantity', 1);
              fd.append('properties[_group_id]', parentGroupId);
              attachSectionsToFormData(fd);
              configAddon.body = fd;

              const respAddon = await fetch(`${routes.cart_add_url}`, configAddon).then(r => r.json());
              finalResponse = respAddon;
              if (respAddon?.status) console.warn('Add-on add error:', respAddon);
            }

            // Redirect to checkout instead of cart
            window.location = window.routes.cart_url.replace('/cart', '/checkout');
            return;
          }
        } catch (e) {
          console.error(e);
        } finally {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!errorHappened) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          this.error = !!errorHappened;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.checkout;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}